import{addToCartTypes} from './../../constants';
const defaultCart = {
  count : 0,
  items : [],
  group : "",
}
//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state=defaultCart, action) =>{
  // console.log(state)
  switch(action.type){
    case 'ADD_ITEMS':
      return {
        ...state,
        count : action.count + 1,
        items : state.items.concat(action.items),
      }

    case 'ADD_GROUP':
      return{
        ...state,
        group : action.group,
      }

    case 'UPDATE_CART':
     return{
       count : action.count,
       items : action.items,
     }
     case addToCartTypes().addBaseItems:
      return {
        ...state,
        count : action.count + 1,
        items : action.items,
      }
    case addToCartTypes().getADClients:
      return {
      ...state,
      ad_client_list : action.ad_client_list
    }

    default:
      return state
  }
}
